<template>
  <div :class="{ 'border border-gray-100 rounded-md p-2': text }">
    <p ref="textEl" class="whitespace-pre-wrap break-words" :class="{ 'line-clamp-2': !expanded }">{{ text || '--' }}</p>
    <button v-if="expanded || isClamped" class="mt-1 text-accent-primary" @click="expanded = !expanded">
      {{ expanded ? 'Show less' : 'Show more' }}
    </button>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { useResizeObserver } from '@vueuse/core';

defineProps({ text: String })

const expanded = ref(false)
const isClamped = ref(false)
const textEl = ref(null)
useResizeObserver(textEl, () => {
  if (!expanded.value) {
    isClamped.value = textEl.value.scrollHeight > textEl.value.clientHeight
  }
})
</script>
